import { render, staticRenderFns } from "./RadarStudentsAttendance.vue?vue&type=template&id=2c4f3048&scoped=true"
import script from "./RadarStudentsAttendance.vue?vue&type=script&lang=js"
export * from "./RadarStudentsAttendance.vue?vue&type=script&lang=js"
import style0 from "../assets/css/radar.css?vue&type=style&index=0&id=2c4f3048&prod&scoped=true&lang=css&external"
import style1 from "./RadarStudentsAttendance.vue?vue&type=style&index=1&id=2c4f3048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4f3048",
  null
  
)

export default component.exports